/**
 * スライドショー画像リンク機能
 * 画像エリアクリック時にリンクに遷移する
 * Flickityの動的状態変化に対応
 */

(function() {
  'use strict';

  function initializeSlideshowLinks(slideshow) {
    const slides = slideshow.querySelectorAll('.slideshow-slide');

    slides.forEach(function(slide) {
      const imageWrapper = slide.querySelector('.slideshow-slide__image-wrapper');
      const backgroundLink = slide.querySelector('.slideshow-slide__background-link');

      if (!imageWrapper || !backgroundLink) return;

      const linkUrl = backgroundLink.getAttribute('href');
      if (!linkUrl) return;

      // 既存のイベントリスナーを削除（重複防止）
      imageWrapper.removeEventListener('click', handleImageClick);

      // 新しいイベントリスナーを追加
      imageWrapper.addEventListener('click', handleImageClick);

      function handleImageClick(event) {
        // コンテンツエリア内のクリックは除外
        const content = slide.querySelector('.slideshow-slide__content');
        if (content && content.contains(event.target)) {
          return;
        }

        // ナビゲーション要素のクリックは除外
        if (event.target.closest('.flickity-prev-next-button') ||
            event.target.closest('.slideshow-pagination') ||
            event.target.closest('.slideshow__current-slide')) {
          return;
        }

        // 背景リンクが無効化されている場合は除外
        const computedStyle = window.getComputedStyle(backgroundLink);
        if (computedStyle.pointerEvents === 'none') {
          return;
        }

        // リンクに遷移
        event.preventDefault();
        window.location.href = linkUrl;
      }
    });
  }

  function initializeAllSlideshows() {
    const slideshows = document.querySelectorAll('.slideshow');
    slideshows.forEach(initializeSlideshowLinks);
  }

  // 初期化
  document.addEventListener('DOMContentLoaded', initializeAllSlideshows);

  // Shopifyセクションの動的読み込みに対応
  document.addEventListener('shopify:section:load', function(event) {
    const slideshow = event.target.querySelector('.slideshow');
    if (slideshow) {
      initializeSlideshowLinks(slideshow);
    }
  });

  // Flickityイベントに対応（スライド変更時の再初期化）
  document.addEventListener('DOMContentLoaded', function() {
    const slideshows = document.querySelectorAll('[data-slideshow]');

    slideshows.forEach(function(slideshow) {
      // Flickityインスタンスの初期化を待つ
      setTimeout(function() {
        const flickityElement = slideshow.querySelector('.slideshow__wrapper');
        if (flickityElement && flickityElement.flickity) {
          // スライド変更時にリンクを再初期化
          flickityElement.flickity.on('change', function() {
            initializeSlideshowLinks(slideshow);
          });
        }
      }, 100);
    });
  });

})();
